/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  Skeleton,
  Stack,
} from '@mui/material';
import {
  Card,
  ListItemCardTitle,
  ListItemCardSubtitle,
  ContextMenuComplete,
} from '@marageti/z4-lib';
import { CardWithPriceNightsProps, CardWithPriceProps, CountryCardProps } from './types';

const formatSubtitle = (minBudg: number, minNights: number): string => (
  `$${minBudg} - ${minNights} Nights`
);

type ContextMenuItemType = {
  label: string;
  action: (e?: any) => void;
};

export const CountryCardWithPriceNights = ({
  displayName,
  minBudgetPPPD,
  minNights,
  onClickEdit,
  onClickDelete = undefined,
}: CardWithPriceNightsProps) => {
  const menuItems: ContextMenuItemType[] = [
    { label: 'Edit', action: onClickEdit },
    ...(onClickDelete ? [{ label: 'Remove', action: onClickDelete }] : []),
  ];

  return (
    <Card>
      <Stack
        direction="row"
        spacing={1}
        justifyContent="space-between"
        alignItems="center"
      >
        <Stack alignItems="space-between" minHeight="45px">
          {displayName ? (
            <ListItemCardTitle>
              {displayName}
            </ListItemCardTitle>
          ) : (<Skeleton variant="text" width="100%" />)}
          <ListItemCardSubtitle>
            { formatSubtitle(minBudgetPPPD, minNights) }
          </ListItemCardSubtitle>
        </Stack>
        <ContextMenuComplete
          id={`country-card-context-menu-${displayName}`}
          items={menuItems}
        />
      </Stack>
    </Card>
  );
};

export const CountryCardWithPrice = ({
  displayName,
  minBudgetPPPD,
  onClickEdit,
  onClickDelete,
}: CardWithPriceProps) => {
  const menuItems: ContextMenuItemType[] = [
    { label: 'Edit', action: onClickEdit },
    ...(onClickDelete ? [{ label: 'Remove', action: onClickDelete }] : []),
  ];

  return (
    <Card>
      <Stack
        direction="row"
        spacing={1}
        justifyContent="space-between"
        alignItems="center"
      >
        <Stack alignItems="space-between" minHeight="45px">
          {displayName ? (
            <ListItemCardTitle>
              {displayName}
            </ListItemCardTitle>
          ) : (<Skeleton variant="text" width="100%" />)}
          <ListItemCardSubtitle>
            {`$${minBudgetPPPD} (PPPD)`}
          </ListItemCardSubtitle>
        </Stack>
        <ContextMenuComplete
          id={`country-card-context-menu-${displayName}`}
          items={menuItems}
        />
      </Stack>
    </Card>
  );
};

const CountryCard = ({
  displayName,
  minBudgetPPPD,
  minNights,
  onClickEdit,
  onClickDelete = undefined,
  withNights,
}: CountryCardProps) => {
  // minNights could be zero so coerce to boolean;
  if (withNights && !!minNights) {
    return (
      <CountryCardWithPriceNights
        displayName={displayName}
        minBudgetPPPD={minBudgetPPPD}
        minNights={minNights}
        onClickEdit={onClickEdit}
        onClickDelete={onClickDelete}
      />
    );
  }
  return (
    <CountryCardWithPrice
      displayName={displayName}
      minBudgetPPPD={minBudgetPPPD}
      onClickEdit={onClickEdit}
      onClickDelete={onClickDelete}
    />
  );
};

export default CountryCard;
